import { render, staticRenderFns } from "./ForbiddenPlayer.vue?vue&type=template&id=501bf236&scoped=true&"
import script from "./ForbiddenPlayer.vue?vue&type=script&lang=js&"
export * from "./ForbiddenPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ForbiddenPlayer.vue?vue&type=style&index=0&id=501bf236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501bf236",
  null
  
)

export default component.exports